import {
  Integration_Handler_Names_Enum,
  Integration_Names_Enum,
  Integration_Service_Names_Enum,
} from '@main/graphql/types.generated';
import { forwardRef } from 'react';

import { ConfigGeneric } from './config-generic';
import { ConfigSharepoint } from './config-sharepoint';
import { ConfigRef } from './types';

export type IntegrationHandlerConfigProps = {
  orgIntegrationId: string;
  providerName: Integration_Names_Enum;
  serviceName: Integration_Service_Names_Enum;
  handlerName: Integration_Handler_Names_Enum;
  evidenceConfig?: unknown;
  isDisabled?: boolean;
  onDirtyChange?: (isDirty: boolean) => void;
};

export const IntegrationHandlerConfig = forwardRef<
  ConfigRef<Record<string, unknown>>,
  IntegrationHandlerConfigProps
>(
  (
    {
      orgIntegrationId,
      providerName,
      serviceName,
      handlerName,
      evidenceConfig,
      isDisabled,
      onDirtyChange,
    },
    ref,
  ) => {
    const ConfigComponent = getConfigComponent(providerName);

    return (
      <ConfigComponent
        ref={ref}
        orgIntegrationId={orgIntegrationId}
        providerName={providerName}
        serviceName={serviceName}
        handlerName={handlerName}
        evidenceConfig={evidenceConfig}
        isDisabled={isDisabled}
        onDirtyChange={onDirtyChange}
      />
    );
  },
);

function getConfigComponent(name: Integration_Names_Enum) {
  switch (name) {
    case Integration_Names_Enum.Sharepoint:
      return ConfigSharepoint;
    default:
      return ConfigGeneric;
  }
}
